import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
import Loadingimg from "../components/loadingimg";
//page links   
import '../master_root/statusbar.css';
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import './feed-details.css';
import { Savefeed } from './Save_feed';

import { MdAdd, MdSend, MdDelete } from 'react-icons/md';
import { join } from 'path-browserify';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
export default function Feeddetails() {
  const query = useQuery();
  const uid = query.get('uid');
  const navigate = useNavigate();
  const location = useLocation();
  //
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [titleInput, settitleInput] = useState("");
  const [descriptionInput, setdescriptionInput] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [keywordsinput, setkeywordsInput] = useState('');

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };
const handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();

    const value = keywordsinput.trim();

    if (!value) return; // Skip if input is empty

    if (value.includes(',')) {
      const newKeywords = value
        .split(',')
        .map(k => k.trim())
        .filter(k => k && !keywords.includes(k));

      const allowed = newKeywords.slice(0, 10 - keywords.length);
      if (allowed.length > 0) {
        setKeywords([...keywords, ...allowed]);
      }
    } else {
      if (!keywords.includes(value) && keywords.length < 10) {
        setKeywords([...keywords, value]);
      }
    }

    setkeywordsInput(''); // Clear input
  }
};

  const removeKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };
  const post_feed = async (e) => {
    var file_url="";
    if (!uid) {
      setLoading(false);
      showToast("User ID missing");
      return;
    }
    if (!titleInput) {
      setLoading(false);
      showToast("Enter Title");
      return;
    }
    if (!descriptionInput) {
      setLoading(false);
      showToast("Enter Title");
      return;
    }
    setLoading(true);
    const result = await Savefeed({
      uid,
      slug:uid,
      title:titleInput,
      file_url:file_url || "https://firebasestorage.googleapis.com/v0/b/editortaskcom.firebasestorage.app/o/banner%2Fbannerh_1920_1080.png?alt=media&token=afac1a3b-738b-4b52-8f59-cd978ad62d3f",
      description:descriptionInput,
      keywords: keywords.join(','),
    });
    if (result.success) {
      showToast('Successfully')
      setTimeout(() => {
        setLoading(false);
       navigate('/'+uid);
        //setKeywords([]);
      }, 2000);
    } else {
      setLoading(false);
      showToast("Failed to publish");
    }

  }
  return (
    <div >
      <div className="status-bar">
        <div className="container_size">
          <div className="status-bar_size">
            <div className='left_body'>
              <VscArrowLeft onClick={handleGoBack} className='back_arrow_btn' />
            </div>
            <div className='name-bar-body'>Feed Details</div>
            <div className='right_body'>
              <div
                onClick={() => navigate('/help')}
                className={`menubutton-icon ${location.pathname === '/help' ? 'active' : ''}`}
                title="Help Center"
              >
                {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}

                <span className="button-text">Help</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>Showcase Your Creative Skills & Projects | EditorTask</title>
          <meta name="description" content="Display your portfolio, projects, and professional skills on EditorTask. From videos and graphics to writing samples and animation—impress potential clients now!" />
          <meta name="keywords" content="showcase portfolio, editor skills, creative portfolio, design showcase, video editing samples, writing projects, animation work, EditorTask talents" />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="Showcase Your Creative Skills & Projects | EditorTask" />
          <meta property="og:description" content="Build your public profile by uploading your work. Share short projects, images, skills, and creative talents to get noticed by job providers and clients." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/skills-showcase" />
          <meta property="og:image" content="https://www.editortask.com/images/showcase_preview.png" />
        </Helmet>


        <div className="container_size">
          <br />
          <div className='post-container'>
            {/* <div className="contact-title">Showcase Your Creative Skills & Projects | EditorTask</div>    */}
          </div>

          <div className='post-container'>
            <div className='post_div'>

              <div className='feed-input-div'>
                <div className='preview-div'>
                  <div className='file-div'>
                    <Lodinging ></Lodinging>
                    {uid}
                  </div>
                   <div className='info-div'>
                    <div className='title-text'>{titleInput}</div>
                    <div className='description-text'>{descriptionInput}</div>
                    </div>
                </div>
                <div className='details-body'>
                  <div className='body-div'>
                    <input
                      onChange={(e) => settitleInput(e.target.value)}
                      className="title_input"
                      maxLength={50}
                      placeholder="Enter Title"></input>
                    <div className='title-count-text'>{50 - titleInput.length}</div>
                  </div>
                  <div className='body-div'>
                    <textarea
                      className='feed-input'
                      maxLength={500}
                      placeholder='Showcase Your Creative Feed & Projects'
                      value={descriptionInput}
                      onChange={(e) => {
                        const textarea = e.target;
                        textarea.style.height = 'auto'; // Reset height
                        textarea.style.height = `${textarea.scrollHeight}px`; // Set to scroll height
                        setdescriptionInput(e.target.value);
                      }}
                    ></textarea>

                    <div className='title-count-text'>{500 - descriptionInput.length}</div>
                  </div>
                  <div className='body-div'>
                    <div className="keyword-container">
                      {keywords.map((word, index) => (
                        <div key={index} className="keyword-chip">
                          {word}
                          <span className="remove" onClick={() => removeKeyword(index)}>×</span>
                        </div>
                      ))}
                      <input
                        value={keywordsinput}
                        onChange={(e) => setkeywordsInput(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="select_input_edit"
                        maxLength={130}
                        placeholder="Enter keywords"
                      />
                    </div>
                    <div className='title-count-text'>{10 - keywords.length}</div>
                  </div>
                  <div className='post-data-div'>
                    <div className='file-btn'>0%</div>
                    <div className='button-send'>
                      <div className='button-ui' onClick={post_feed}>
                        {loading ? <Loadingimg /> : <MdSend className='icon' />}
                        Publish</div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
